<div
    #slideToggle
    class="slide-toggle container {{ class }}"
    [ngClass]="{ toggled: toggled, disabled: disabled }"
    av-data="slide-toggle-slider"
    (click)="toggle()"
    [attr.av-data]="avData">
    <div class="moveable-part" [ngClass]="{ toggled: toggled }"></div>
</div>
